// extracted by mini-css-extract-plugin
export default {"dateBtn":"SwitchDate_dateBtn__6FG3G","active":"SwitchDate_active__jqdfP"};